/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { isChrome, isEdge, isSafari } from 'react-device-detect';

export const useBrowserInfo = () => ({
    browserType: isChrome ? 'chrome' : isEdge ? 'edge' : isSafari ? 'safari' : ''
});
